import { render, staticRenderFns } from "./ModalPagamento.vue?vue&type=template&id=327ac2c0&"
import script from "./ModalPagamento.vue?vue&type=script&lang=js&"
export * from "./ModalPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports